var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 24 24","fill":"#6400FF"}},[_c('title',[_vm._v("forum-outline")]),_c('path',{attrs:{"d":"M15,4V11H5.17L4,12.17V4H15M16,2H3A1,1 0 0,0 2,3V17L6,13H16A1,1 0 0,0 17,12V3A1,1 0 0,0 16,2M21,6H19V15H6V17A1,1 0 0,0 7,18H18L22,22V7A1,1 0 0,0 21,6Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }